<template>
	<div class="cart-quantity" >
		<select v-if="view == 'select'" v-model.number="selectVal" @change="selectVal < 10 ? $emit('change', selectVal) : view = 'input'; selectVal = '';" >
			<option value=""></option>
			<option v-for="n in (max > 10 ? 10 : max)" :value="n">{{ n < 10 ? n : '10+' }}</option>
		</select>
		<quantity v-show="view != 'select'" v-model.number="val" hide-controls :step="step" :max-quantity="max" @change="$emit('change', val); view = 'select';" ></quantity>
		<div v-if="view == 'select'" class="cart-quantity__label" >{{ val }}</div>
	</div>
</template>

<script>
export default {
	name : 'CartQuantity',
	props : {
		value : {
			type : Number,
			default : 1,
		},
		step : {
			type : Number,
			default : 1,
		},
		min : {
			type : Number,
			default : 1,
		},
		max : {
			type : Number,
			default : 150,
		},
	},
	data : () => ({
		view : 'select',
		selectVal : '',
		val : 0,
	}),
	mounted () {
		this.val = this.value;
		if (this.val > this.max) {
			this.val = this.max;
		}
	},
	model : {
		prop : 'value',
		event : 'change',
	},
	watch : {
		value (value) {
			this.val = value;
		},
		view (view) {
			if (view == 'input') {
				setTimeout(() => {
					this.$el.querySelector('input[type="text"]').focus();
				}, 500);
			}
		},
	},
	methods : {
		change (val) {
			this.$emit('change', val);
		},
	},
}
</script>

<style scoped >
.cart-quantity {
    position: relative;
    }
    .cart-quantity__label {
        position: absolute;
        top: 0;
        left: 0;
        height: 34px;
		display: flex;
    	align-items: center;
		pointer-events: none;
        }
</style>
